import {
    TOGGLE_SETTING_UI_SIDEBAR,
    SYSTEM_BOOT_RESOURCES_LOADED
} from './types'
import {api} from '../api';

export const toggleSidebar = () => {
    return ({
        type: TOGGLE_SETTING_UI_SIDEBAR
    })
}


// WEBPACK FOOTER //
// ./src/actions/system.js